import { Hero } from './Hero';
import { LogoList } from './LogoList';
import { CallToAction } from './CallToAction';
import { PressList } from './PressList';
import { TextGrid } from './TextGrid';
import { TextBlock } from './TextBlock';
import { Visual } from './Visual';
import { Quotes } from './Quotes';
import { QuotesVideo } from './QuotesVideo';
import { FeaturedArtists } from './FeaturedArtists';
import { Feature } from './Feature';
import { MasteringDemos } from './MasteringDemos';
import { Faq } from './Faq';
import { VideoPlayer } from './VideoPlayer';
import { Blog } from './Blog';
import { ResetPassword } from './ResetPassword';
import { Signup } from './Signup';
import { Pricing } from './Pricing';
import { LinkList } from './LinkList';

export enum SupportedPrismicSlicesEnum {
    blog = 'blog',
    cta = 'cta',
    faq = 'faq',
    feature = 'feature',
    featured_artists = 'featured_artists',
    hero = 'hero',
    logoList = 'logo_list',
    mastering_demos = 'mastering_demos',
    pressList = 'press_list',
    pricing = 'pricing',
    quotes = 'quotes',
    quotes_video = 'quotes_-_video',
    reset_password = 'reset_password',
    signup = 'signup',
    textBlock = 'text_block',
    text_grid = 'text_grid',
    videoplayer = 'videoplayer',
    visual = 'visual',
    linklist = 'linklist',
}

type SlicesTypesMapping = { [index: string]: any };

export const slicesTypesMapping: SlicesTypesMapping = {
    [SupportedPrismicSlicesEnum.blog]: Blog,
    [SupportedPrismicSlicesEnum.cta]: CallToAction,
    [SupportedPrismicSlicesEnum.faq]: Faq,
    [SupportedPrismicSlicesEnum.feature]: Feature,
    [SupportedPrismicSlicesEnum.feature]: Feature,
    [SupportedPrismicSlicesEnum.featured_artists]: FeaturedArtists,
    [SupportedPrismicSlicesEnum.hero]: Hero,
    [SupportedPrismicSlicesEnum.logoList]: LogoList,
    [SupportedPrismicSlicesEnum.mastering_demos]: MasteringDemos,
    [SupportedPrismicSlicesEnum.pressList]: PressList,
    [SupportedPrismicSlicesEnum.pricing]: Pricing,
    [SupportedPrismicSlicesEnum.quotes]: Quotes,
    [SupportedPrismicSlicesEnum.quotes_video]: QuotesVideo,
    [SupportedPrismicSlicesEnum.reset_password]: ResetPassword,
    [SupportedPrismicSlicesEnum.signup]: Signup,
    [SupportedPrismicSlicesEnum.textBlock]: TextBlock,
    [SupportedPrismicSlicesEnum.text_grid]: TextGrid,
    [SupportedPrismicSlicesEnum.text_grid]: TextGrid,
    [SupportedPrismicSlicesEnum.videoplayer]: VideoPlayer,
    [SupportedPrismicSlicesEnum.visual]: Visual,
    [SupportedPrismicSlicesEnum.linklist]: LinkList,
};
